var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    height: 39,
    viewBox: "0 0 64 39",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.428,30H12.571A4.593,4.593,0,0,0,8,34.588V64.412A4.593,4.593,0,0,0,12.571,69H67.428A4.593,4.593,0,0,0,72,64.412V34.588A4.593,4.593,0,0,0,67.428,30ZM12.571,32.294H67.428a2.3,2.3,0,0,1,2.286,2.294v4.588H10.286V34.588A2.3,2.3,0,0,1,12.571,32.294ZM67.428,66.706H12.571a2.3,2.3,0,0,1-2.286-2.294V46.059H69.714V64.412A2.3,2.3,0,0,1,67.428,66.706Z",
    transform: "translate(-8 -30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.714 55.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2.286,
    width: 11.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.428 55.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2.286,
    width: 11.429
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.dbd73aea739b20aebad751b5cb8a06c6.svg";
export { ForwardRef as ReactComponent };